import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "mt-2 border border-gray-400 rounded" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 py-2 bg-gray-100 border-b border-gray-400" }, "Discount Details", -1)
const _hoisted_4 = { class: "pt-0 capitalize" }
const _hoisted_5 = { class: "pt-0 capitalize" }
const _hoisted_6 = {
  key: 0,
  class: "px-2 mt-1 text-sm text-white rounded-full bg-green w-fit"
}
const _hoisted_7 = {
  key: 1,
  class: "px-2 mt-1 text-sm text-black rounded-full bg-danger w-fit"
}
const _hoisted_8 = { class: "pt-0 capitalize" }
const _hoisted_9 = {
  key: 0,
  class: "pt-0 capitalize"
}
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "10.00" }, "10", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "20.00" }, "20", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: "30.00" }, "30", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", { value: "40.00" }, "40", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "50.00" }, "50", -1)
const _hoisted_16 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "block h-10 px-4 py-2 font-medium text-gray-900 bg-gray-300 border border-gray-400 rounded-r w-1/8" }, "%", -1)
const _hoisted_18 = { class: "flex space-x-4" }
const _hoisted_19 = { class: "flex items-center w-1/2 space-x-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Unlimited", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: true
}, "Active", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: false
}, "Inactive", -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "flex py-6 space-x-6" }

import { ref } from "vue";

import DefaultButton from "@/components/DefaultButton.vue";
import TagSelector from "@/components/TagSelector.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import TitleHeader from "@/components/TitleHeader.vue";

import api from "@/api/api";
import { Country, Discount, Tag } from "@/types";
import { useGlobalStore } from "@/store";
import { useRoute } from "vue-router";
import { formatDate } from "@/utils/dates";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditDiscount',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const globalStore = useGlobalStore();

const isDeleting = ref(false);
const isPublishing = ref(false);

const countries = ref([] as Country[]);
const tags = ref([] as Tag[]);

const discount = ref({} as Discount);

const datepicker = ref(null);

function setDate(date: Date) {
  if (!date) return;

  discount.value.expires_at = formatDate(date);
  datepicker.value.closeMenu();
}

async function saveDiscount(e: any) {
  try {
    if (!e.submitter.id) {
      isDeleting.value = true;
    } else {
      isPublishing.value = true;
    }
    console.log(discount.value.verifone_product_code)
    const response = (await api.discounts.updateDiscount(discount.value.id, discount.value)).data;

    globalStore.toast("SUCCESS", "Discount updated");
    return (window.location.href = `/dashboard/courses/discounts/${response.discount.id}`);
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", "Error updating Discount");
  } finally {
    isDeleting.value = false;
    isPublishing.value = false;
  }
}

/** Fetch API Data */
countries.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.misc.listCountries())),
  __temp = await __temp,
  __restore(),
  __temp
)).countries;
tags.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.tags.listTags())),
  __temp = await __temp,
  __restore(),
  __temp
)).data.tags;

discount.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.discounts.getDiscount(String(route.params.id)))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.discount;

return (_ctx: any,_cache: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('edit-discount')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("form", {
        class: "mt-8",
        onSubmit: _withModifiers(saveDiscount, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(ListRowItem, {
            title: _ctx.$t('name')
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_4, _toDisplayString(discount.value.name), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('code')
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_5, _toDisplayString(discount.value.code), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('renewal-only')
          }, {
            default: _withCtx(() => [
              (discount.value.renewal_only)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, "True"))
                : _createCommentVNode("", true),
              (!discount.value.renewal_only)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "False"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('merchant-name')
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_8, _toDisplayString(discount.value.merchant_name), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          (discount.value.merchant_name === '2checkout' && !discount.value.renewal_only)
            ? (_openBlock(), _createBlock(ListRowItem, {
                key: 0,
                title: _ctx.$t('verifone-product-code')
              }, {
                default: _withCtx(() => [
                  (discount.value.usagecount > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(discount.value.verifone_product_code), 1))
                    : _createCommentVNode("", true),
                  (discount.value.usagecount === 0)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        onkeypress: "return event.which != 32",
                        type: "text",
                        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((discount.value.verifone_product_code) = $event))
                      }, null, 512)), [
                        [_vModelText, discount.value.verifone_product_code]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true),
          (discount.value.usagecount === 0)
            ? (_openBlock(), _createBlock(ListRowItem, {
                key: 1,
                title: _ctx.$t('percent-off')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("select", {
                      class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((discount.value.percent_amount) = $event))
                    }, _hoisted_16, 512), [
                      [_vModelSelect, discount.value.percent_amount]
                    ]),
                    _hoisted_17
                  ])
                ]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true),
          _createVNode(ListRowItem, {
            title: _ctx.$t('event-tag')
          }, {
            default: _withCtx(() => [
              _createVNode(TagSelector, {
                onChange: _cache[2] || (_cache[2] = e => (discount.value.tag_id = e[0])),
                type: "event",
                modelValue: discount.value.tag_id,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((discount.value.tag_id) = $event)),
                tags: discount.value.tag ? [discount.value.tag] : []
              }, null, 8, ["modelValue", "tags"])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('expires-at')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DatePicker, {
                ref_key: "datepicker",
                ref: datepicker,
                onInternalModelChange: _cache[4] || (_cache[4] = e => setDate(e)),
                required: "",
                "enable-time-picker": false,
                format: "dd/MMM/yyyy",
                class: "mt-1",
                "min-date": new Date(),
                modelValue: discount.value.expires_at,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((discount.value.expires_at) = $event))
              }, null, 8, ["min-date", "modelValue"])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('limit-total-uses')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  min: "0",
                  step: "1",
                  id: "maxm",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((discount.value.limit) = $event)),
                  class: "block w-1/2 h-10 py-2 text-gray-900 border border-gray-600 rounded"
                }, null, 512), [
                  [_vModelText, discount.value.limit]
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (discount.value.limit = 0)),
                    class: "rounded"
                  }, null, 32),
                  _hoisted_20
                ])
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(ListRowItem, {
            title: _ctx.$t('status')
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("select", {
                id: "subscription",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((discount.value.active) = $event)),
                class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                required: ""
              }, _hoisted_23, 512), [
                [_vModelSelect, discount.value.active]
              ])
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(DefaultButton, {
            id: true,
            type: "primary",
            "is-form-submit": true,
            loading: isPublishing.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("Save Changes")
            ]),
            _: 1
          }, 8, ["loading"]),
          (discount.value.active)
            ? (_openBlock(), _createBlock(DefaultButton, {
                key: 0,
                id: false,
                type: "danger",
                "is-form-submit": true,
                loading: isDeleting.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Delete Discount")
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true)
        ])
      ], 40, _hoisted_1)
    ])
  ], 64))
}
}

})